import { SYNC_PRODUCTS_REQUEST, SYNC_PRODUCTS_SUCCESS, SYNC_PRODUCTS_FAILURE, SYNC_PRODUCTS_REST, } from "../../actions";
const initialState = {
    syncProducts: [],
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SYNC_PRODUCTS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, syncProducts: null });
        case SYNC_PRODUCTS_SUCCESS:
            return Object.assign(Object.assign({}, state), { syncProducts: action.payload, isLoading: false, error: null });
        case SYNC_PRODUCTS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case SYNC_PRODUCTS_REST:
            return Object.assign(Object.assign({}, state), { syncProducts: null, isLoading: true, error: null });
        default:
            return state;
    }
};
export default reducer;
